import * as React from 'react';

interface IProps {
  className?: string;
}

export const Retail: React.FC<IProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      fill="none"
      viewBox="0 0 80 80"
      className={className}
    >
      <path fill="#0468FF" fillOpacity="0.1" d="M8 8h48l8 20v4h-4v48H4V32H0v-4L8 8z" />
      <path
        fill="#0468FF"
        fillRule="evenodd"
        d="M54.828 34.828L52 32l-.172.172L49 35 36 48H24l7 32h42l7-32H67.657l-13-13 .171-.172zm-3 3L41.657 48H62L51.828 37.828z"
        clipRule="evenodd"
      />
      <path fill="#fff" fillRule="evenodd" d="M32 55h40v2H32v-2zm4 8h32v2H36v-2zm28 8H40v2h24v-2z" clipRule="evenodd" />
    </svg>
  );
};
